module.exports = __webpack_public_path__ + "static/media/icon-eidt.fdab0975.svg";